import { Button } from '@forwardflow/ui'
import Icon from '@forwardflow/ui/Icons'
import { Link, useParams } from 'react-router-dom'

export const TopBarIdle = () => {
   const { title } = useParams()

   return (
      <>
         <div className="bg-white/5 h-[60px] rounded-lg flex items-center">
            <Link to="/campaign">
               <Button className="!w-[54px] h-[54px] border-transparent bg-transparent !rounded-lg !mt-0 ml-1 mr-5">
                  <Icon
                     name="arrow-right"
                     className="rotate-180 fill-white"
                     width={20}
                     height={20}
                  />
               </Button>
            </Link>

            <span className="text-[#717171]">
               <Link to="/dashboard"> Home /</Link>
               <Link to="/campaign"> campaign /</Link>
               {title ? <span> {title} /</span> : null}
               <span className="text-white"> Activate</span>
            </span>
         </div>
      </>
   )
}
